/// <reference path='../_all.ts' />

module training {
  'use strict';

  function addDays(date : Date, days : number) : Date {
    var _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    var utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

    var utc2 = utc1 +  days * _MS_PER_DAY;
    return new Date(utc2);
  }
  
  
  export class TrainingCtrl {

    public static $inject = [
      '$scope',
      'pageMetaService',
      'trainingService',
      '$timeout',
    ];

    constructor(
      private $scope: ITrainingCtrlScope,
      private pageMetaService: navigation.IPageMetaService,
      private trainingService: ITrainingService,
      private $timeout: ng.ITimeoutService
    ) {
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
      
      $scope.model = $scope.master = <{ [index: number]: TrainingFormData }>{};
      $scope.noTrainings = true;


      this.trainingService.loadTrainings()
        .then((response: {data :TrainingServiceData}) => {
          
          if(!response.data || !response.data.Trainings) {
            $scope.noTrainings = true;
            return;
          }

          response.data.Trainings.forEach((t) => {
            var m : TrainingFormData = $scope.master[t.Id] = <TrainingFormData>{};
            m.teilnehmer = response.data.Name;
            m.email = response.data.EMail;
            m.vertretung = response.data.Agency;
            m.hotelFrom = addDays(t.StartDate, -1);
            m.hotelTo = t.EndDate;
            this.$scope.model[t.Id] = angular.copy(this.$scope.master[t.Id]);
          })
          $scope.data = response.data.Trainings;
        });

    }

    register($event : Event, childScope : ITrainingRepeatScope, model : TrainingFormData, t : Training) {   

      childScope.error = false;
      childScope.success = false;

      model.submitDate = new Date();
      this.trainingService.registerTraining(model, t.Id).then(() => {
        childScope["FormAnmeldung_" + t.Id].$setPristine();
        childScope["FormAnmeldung_" + t.Id].$setUntouched();
        childScope.anmeldung = angular.copy(this.$scope.master[t.Id]);
        childScope.success = true;
      }).catch(() => {
        childScope.error = true;
      }).finally(() => {
        childScope.disabled = false;
      });

    }

    initModel(childScope : ITrainingRepeatScope, t : Training) {
      childScope.anmeldung = childScope.$parent.model[t.Id];
    }

    registrationPossible(date: Date) {
      return date.getTime() > Date.now();
    }

  }
}